/* global toastr */
import { BaseAdminModelView } from '../model_view'
import { wrapView, request } from '../../smart_bps/lib/utils'
import { stateToProps } from '../../smart_bps/admin/base_view'
import {store} from "../../index";

class DocumentTypeRefAdminModelView extends BaseAdminModelView {
  constructor(props) {
    super(props)
    this.renderContentLeftAction = this.renderContentLeftAction.bind(this)
  }

  renderContentLeftAction() {
    const saving = Boolean(this.state.saving)
    return (
      <div className="card mb-3" key="actions">
        <div className="card-body p-2">
          <span
            className={`btn btn-outline-primary waves-effect p-2 me-2${saving ? ' disabled' : ''}`}
            style={saving ? { pointerEvents: 'none', opacity: 0.65 } : undefined}
            onClick={saving ? undefined : this.saveObject}
            aria-disabled={saving}
          >
            <span className="ti ti-xs ti-check me-1" />
            {saving ? 'Сохранение…' : 'Сохранить'}
          </span>
          {this.state.perms && this.state.perms.includes('delete') && (
            <button
              type="button"
              className="btn btn-outline-danger waves-effect p-2 me-2"
              onClick={this.deleteObject}
              disabled={saving}
            >
              <span className="ti ti-xs ti-trash me-1" />
              Удалить
            </button>
          )}
        </div>
      </div>
    )
  }

  /** Форма на всю ширину страницы, без правой колонки col-md-4. */
  renderContent() {
    return (
      <div className="row">
        <div className="col-12">
          {this.renderContentLeft()}
        </div>
      </div>
    )
  }

  renderContentRight() {
    return null
  }

  deleteEmptyTableRows(callback) {
    const tables = this.state.form_data?.flow_stage_links_lnk || [];

    const filteredTables = tables.filter(item => {
      return !(
        !(item.document_name || '').trim() &&
        item.is_required === false &&
        item.track_validity_period === false &&
        (!item.stages_lnk || item.stages_lnk.length === 0) &&
        (!item.date_types_lnk || item.date_types_lnk.length === 0)
      );
    });

    this.setState(
      {
        form_data: { ...this.state.form_data, flow_stage_links_lnk: filteredTables }
      },
      () => {
        // Этот код выполнится ПОСЛЕ обновления стейта
        if (typeof callback === 'function') callback();
      }
    );
  }

  saveObject() {
    if (this.state.saving) return
    const that = this

    this.setState({ saving: true }, () => {
      this.deleteEmptyTableRows(() => {
        request({
          method: 'post',
          url: `/api/admin/${this.model_name}/${that.object_id}/update_object`,
          data: {
            new_data: that.state.form_data,
            old_data: that.state.form_data_initial,
          },
          success: (data) => {
            const finish = () => {
              store.dispatch({ type: 'admin_list_clean' })
              if (data.form_data) {
                that.dataToState(data)
                toastr.success('Изменения сохранены')
                if (data.message) toastr.success(data.message)
              }
              if (data.errors) {
                const errs = { ...data.errors }
                if (errs._toast) {
                  toastr.warning(errs._toast, 'Внимание')
                  delete errs._toast
                } else {
                  toastr.warning(
                    'Изменения не были сохранены. Нужно исправить ошибки в форме документа',
                    'Внимание'
                  )
                }
                that.setState({ form_errors: Object.keys(errs).length > 0 ? errs : undefined })
              }
            }
            that.setState({ saving: false }, finish)
          },
          error: () => {
            that.setState({ saving: false })
            toastr.error('Ошибка сохранения')
          },
        })
      })
    })
  }

}

export default wrapView(DocumentTypeRefAdminModelView, stateToProps)